import { Lazy } from '@betgames/bg-state-manager';
import { storageRepository } from '@betgames/bg-tools';
import { sessionStore } from '@bg-shared/business/Session';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import SelectedGamesStore from './SelectedGames.store';

export const selectedGames = new Lazy(
    () => new SelectedGamesStore(partnerSettingsStore, sessionStore, storageRepository),
);
